import { useAudioTrack, useDaily, useLocalSessionId, useParticipantIds, useVideoTrack } from '@daily-co/daily-react'
import Actions from '../Actions'

type DailyVideoActionsProps = {
  actions: {
    chat: () => void
    hangup: () => void
    settings: () => void
    chatBadgeValue?: string | number
  }
}

const DailyVideoActions = ({ actions }: DailyVideoActionsProps) => {
  const allParticipantsIds = useParticipantIds()
  const localSessionId = useLocalSessionId()
  const callObject = useDaily()
  const localAudio = useAudioTrack(localSessionId)
  const localVideo = useVideoTrack(localSessionId)

  const isAudioMuted = localAudio.isOff
  const isVideoMuted = localVideo.isOff

  const { chat, hangup, settings, chatBadgeValue } = actions || {}

  if (!allParticipantsIds.length) {
    return null
  }

  return (
    <Actions
      onChatClick={chat}
      onHangupClick={hangup}
      onSettingsClick={settings}
      onAudioClick={() => callObject.setLocalAudio(isAudioMuted)}
      isAudioMuted={isAudioMuted}
      onVideoClick={() => callObject.setLocalVideo(isVideoMuted)}
      isVideoMuted={isVideoMuted}
      chatBadgeValue={chatBadgeValue}
    />
  )
}

export default DailyVideoActions
